// Encodes a given string to base64
export const encodeBase64 = str => btoa(encodeURIComponent(str));

// Decodes a given base64 string
export const decodeBase64 = str => decodeURIComponent(atob(str));
